export default "__VITE_ASSET__DLmjAepM__"